import { render, staticRenderFns } from "./Vincular.vue?vue&type=template&id=ccc29e4c&scoped=true"
import script from "./Vincular.vue?vue&type=script&lang=js"
export * from "./Vincular.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=ccc29e4c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc29e4c",
  null
  
)

export default component.exports